


































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { track } from 'frontend/utils/analytics';
import Button from 'frontend/components/Button.vue';
import Modal from 'frontend/components/Modal.vue';

@Component({
  components: {
    Button,
    Modal,
  },
})
export default class ICPNudgeModal extends Vue {
  @Prop({ type: String, required: true })
  private courseName!: string;

  private mounted() {
    track('ui', {
      action: 'modal',
      element_id: 'viewed_icp_locked_modal_nudge',
    });
  }

  private handleClose() {
    this.$emit('close');
  }
}
